var ezdia;
(function (ezdia) {
    function getBackBtn(props) {
        var htmlContent = "";
        if (props) {
            var title = props.title, href = props.href;
            htmlContent = "<div>\n        <a title=\"" + title + "\" class=\"btn btn-default btn-circle\" href=\"" + href + "\">\n          <i class=\"fa ez-back-nav\"></i>\n        </a>                        \n      </div>";
        }
        return htmlContent;
    }
    function getTitle(props, titleOnly) {
        var htmlContent = "";
        var sep = " /";
        if (titleOnly) {
            sep = "";
        }
        if (props) {
            var pageLabel = props.pageLabel, _a = props.title, title = _a === void 0 ? '' : _a;
            htmlContent = "<div class=\"heading\" title=\"" + title + "\">" + pageLabel + sep + "</div>";
        }
        return htmlContent;
    }
    function accountOptions(options, value) {
        var htmlContent = [];
        Object.entries(options).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], label = _b[1];
            if (typeof label !== 'string') {
                htmlContent.push("<optgroup label=\"" + key + "\">" + accountOptions(label, value) + "</optgroup>");
            }
            else {
                var selected = void 0;
                if (value === key) {
                    selected = "selected=\"selected\"";
                }
                htmlContent.push("<option " + selected + " value=\"" + key + "\">" + label + "</option>");
            }
        });
        return htmlContent.join('');
    }
    function account(_a) {
        var column = _a.column, value = _a.value;
        var id = column.id, name = column.name, options = column.config.options;
        return "<select id=\"" + id + "\" name=\"" + name + "\" class='form-control'>\n      " + accountOptions(options, value) + "\n    </select>";
    }
    function filter(pageFilters) {
        var column = pageFilters.column;
        var label = column.label, name = column.name, config = column.config;
        var icon = (config === null || config === void 0 ? void 0 : config.icon) || "fa fa-folder-open-o";
        var options = (config === null || config === void 0 ? void 0 : config.options) || {};
        var input;
        if (name === 'accountName') {
            input = account(pageFilters);
        }
        else if (Object.keys(options).length === 1) {
            var _a = __read(Object.entries(options)[0], 2), key = _a[0], klabel = _a[1];
            input = "<input type=\"hidden\" name=\"role\" id=\"role\" value=\"" + key + "\"></input>\n        <div class=\"input-group-text\" >" + klabel + "</div>";
        }
        else {
            input = $.ezdia.inputs.create(pageFilters);
        }
        return "<div>\n      <div title=\"" + label + "\" class=\"ez-input-group\">\n        <label class=\"input-group-addon\"><i class=\"" + icon + "\"></i></label>\n        " + input + "\n      </div>\n    </div>";
    }
    function getfilters(pageFilters) {
        var htmlContentArray = [];
        pageFilters.forEach(function (column) {
            var htmlContent = filter(column);
            htmlContentArray.push(htmlContent);
        });
        return htmlContentArray.join('');
    }
    function getMarkup(_a) {
        var pageFilters = _a.pageFilters, backBtn = _a.backBtn, pageTitle = _a.pageTitle, _b = _a.classes, classes = _b === void 0 ? '' : _b;
        return "<div id=\"ez-pagehead-account-role\" class=\"ez-pagehead-account-role " + classes + "\">\n      " + getBackBtn(backBtn) + getTitle(pageTitle) + getfilters(pageFilters) + "\n    </div>";
    }
    function getPageTitle(pageTitle) {
        return "<div id=\"ez-pagehead-account-role\" class=\"ez-pagehead-account-role ez-open-project-pagehead\">\n      " + getTitle(pageTitle, true) + "\n    </div>";
    }
    function customDateRange(_a, lastYear) {
        var rgComCb = _a.rgComCb, rgComInput = _a.rgComInput, rgComOpt = _a.rgComOpt, rgComW = _a.rgComW, rgInput = _a.rgInput, rgW = _a.rgW, sCb = _a.sCb, sInput = _a.sInput;
        var tab = $.ezdia.config.pageParams.tab;
        var comapreDateHtml = '';
        var comapreDateCalHtml = '';
        if (tab === 'eza_lists') {
            comapreDateCalHtml = "<div id=\"" + rgComInput + "__cal\" class=\"date-c-cal-container\"></div>";
            comapreDateHtml = "<div class=\"row\">\n        <div class=\"col-md-6 compare-date-range\">\n          <div class=\"checkbox\">\n            <label>\n              <input id=\"" + rgComCb + "\" name=\"\" type=\"checkbox\"> Compare to\n            </label>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" id=\"" + rgComW + "\" hidden>\n        <div class=\"col-md-6\" >\n          <div data-row=\"input\" class=\"inputs\">\n            <select id=\"" + rgComOpt + "\" name=\"channel\" class=\"form-control \">\n              <option value=\"custom_date\">Custom date range</option>\n              <option value=\"last_year\" " + (lastYear ? '' : 'disabled') + ">Last year</option>\n            </select>\n          </div>\n        </div>\n        <div class=\"col-md-6\"  id=\"" + rgComInput + "__row\">\n          <div data-row=\"row\" class=\"form-group column-layout-two\">\n            <div data-row=\"input\" class=\"inputs\">\n              <input class=\"form-control\" id=\"" + rgComInput + "\" type=\"text\" name=\"" + rgComInput + "\" />\n              <div class=\"text-right text-info\"><strong id=\"" + rgComInput + "__days\"></strong></div>\n            </div>\n          </div>          \n        </div>\n      </div>";
        }
        return "<form class=\"ezdia-form ezdia-form-cus-d-r\">\n      <div class=\"checkbox\">\n        <label>\n          <input id=\"" + sCb + "\" name=\"\" type=\"checkbox\"> Single date\n        </label>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <div data-row=\"row\" id=\"" + sInput + "__row\" class=\"form-group column-layout-two\" hidden>\n            <div data-row=\"input\" class=\"inputs\">\n              <input class=\"form-control\" id=\"" + sInput + "\" type=\"text\" name=\"" + sInput + "\"/>\n            </div>\n          </div>        \n        </div>\n      </div>\n      <div id=\"" + rgW + "\">\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div data-row=\"row\" id=\"" + rgInput + "__row\" class=\"form-group column-layout-two\">\n              <div class=\"control-label\">Select dates</div>\n              <div data-row=\"input\" class=\"inputs\">\n                <input class=\"form-control\" id=\"" + rgInput + "\" type=\"text\" name=\"" + rgInput + "\"/>\n                <div class=\"text-right text-info\"><strong id=\"" + rgInput + "__days\"></strong></div>\n              </div>\n            </div>\n          </div>\n        </div>\n        " + comapreDateHtml + "\n      </div>\n    </form>\n    <div id=\"" + rgInput + "__cal\" class=\"date-cal-container\"></div>" + comapreDateCalHtml;
    }
    var templates;
    (function (templates) {
        templates.pageFiltersAndHeading = {
            getMarkup: getMarkup,
            getPageTitle: getPageTitle,
            customDateRange: customDateRange
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
